import { render, staticRenderFns } from "./ExecWhatsapp.vue?vue&type=template&id=2af88c08"
import script from "./ExecWhatsapp.vue?vue&type=script&lang=js"
export * from "./ExecWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports